import { Inject, Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { HttpClient } from '@angular/common/http';
import { TextProposal } from './textkuerzel';
import { API_BASE_URL_SERVICE } from '../../../../projects/kiene-core/src/lib/kiene-core.config';

@Injectable({ providedIn: 'root' })
export class TextProposalService {
    constructor(
        private readonly http: HttpClient,
        @Inject(API_BASE_URL_SERVICE) private readonly apiBaseUrl: string,
    ) {}

    createTextProposal(tp: TextProposal): Observable<TextProposal> {
        return this.http.post<TextProposal>(this.apiBaseUrl + 'textkuerzel/create.php', tp);
    }

    loadTextProposalForKey(key: string): Observable<TextProposal> {
        return this.http.get<TextProposal>(this.apiBaseUrl + 'textkuerzel/search.php?textkuerzel=' + key);
    }

    updateTextProposal(tp: TextProposal): Observable<TextProposal> {
        return this.http.post<TextProposal>(this.apiBaseUrl + 'textkuerzel/update.php', tp);
    }

    deleteTextProposal(tp: TextProposal): Observable<TextProposal> {
        return this.http.post<TextProposal>(this.apiBaseUrl + 'textkuerzel/delete.php', tp);
    }
}
